import { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons'

export type MagicLinkNotificationProps = {
    email: string
    title?: string
    subtitle?: string
    details?: ReactNode
    note?: string
    onUseDifferentEmail?: () => void
}

export default function MagicLinkNotification({
    email,
    title = 'Check your email!',
    subtitle,
    details,
    note = 'If you do not see it in a few minutes, check your spam folder or try again.',
    onUseDifferentEmail,
}: MagicLinkNotificationProps): React.JSX.Element {
    const fallbackSubtitle = `We sent a magic link to ${email}. Use it to continue.`

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
            <div className="w-full max-w-md bg-white shadow-lg rounded-xl p-10 space-y-6 text-center">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 text-ctxt-blue">
                    <FontAwesomeIcon
                        icon={faEnvelopeOpenText}
                        className="text-3xl"
                    />
                </div>
                <div className="space-y-3">
                    <h1 className="text-2xl font-bold text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 whitespace-pre-line">
                        {subtitle || fallbackSubtitle}
                    </p>
                    {details ? (
                        <div className="text-sm text-gray-500 space-y-2">
                            {details}
                        </div>
                    ) : null}
                    {note && <p className="text-xs text-gray-400">{note}</p>}
                </div>
                {onUseDifferentEmail && (
                    <button
                        type="button"
                        className="text-sm text-blue-600 hover:underline"
                        onClick={onUseDifferentEmail}
                    >
                        Use a different email
                    </button>
                )}
            </div>
        </div>
    )
}
